import script from "./ApiStatusBannerComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiStatusBannerComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ApiStatusBannerComponent.vue?vue&type=style&index=0&id=76c9f4ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c9f4ac"]])

export default __exports__